import PropTypes from 'prop-types'
import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import { Formik, Form, Field } from 'formik'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { Preloader } from 'SRC/ui/Preloader'
import { FormNotification } from 'SRC/modules/ads/edit/components/FormNotification'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { Item as PromoItem } from 'SRC/modules/ads/add/components/FormPage/PromoPeriods/Item'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'
import { fetchCountries } from 'SRC/modules/geoObjects/countries/actions'
import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'
import { getListings } from 'SRC/modules/ads/lisitings/selectors'
import { setFormLoading } from 'SRC/modules/common/actions'
import { getFormLoading } from 'SRC/modules/common/selectors'
import { PhoneInput, TextInput } from 'SRC/ui/FormElementsNew'
import { FormikRequired } from 'SRC/core/validators'
import { CommonApi } from 'SRC/modules/common/api'
import config from 'SRC/config/config.json'

export class ActivatePromoCKB extends React.PureComponent {
  constructor(props) {
    super(props)

    this.adApi = new AdApi()
    this.cookies = new CookiesHelper()

    this.state = {
      activeListing: null,
      showNotification: false,
      notificationMessage: '',
      dial: '382'
    }
  }

  componentDidMount = () => {
    this.props.fetchCountries()
  }

  hideNotification = () => {
    this.setState({
      showNotification: false
    })
  }

  showNotification = () => {
    this.setState({
      showNotification: true
    })
  }

  prepareCountries = () => this.props.countries.filter(country => !country.parent).map(country => {
    const isGrouped = Boolean(this.props.countries.filter(item => item.parent === country.id).length)
    return {
      id: country.id,
      label: country.label,
      isGrouped,
      isDisabled: false,
      value: country.id,
      options: isGrouped ? this.props.countries.filter(item => item.parent === country.id).map(item => ({
        value: item.id,
        isDisabled: false,
        label: item.label
      })) : null
    }                                               
  })

  setDial = e => {
    const { countries } = this.props
    const selectedCountry = e.target.value
    const country = countries.find(country => country.id === Number(selectedCountry))

    if (country && country.dial) {
      this.setState({ dial: country.dial })
    }
  }

  onListingChange = event => {
    const value = Number(event.target.dataset.id)
    this.setState({ activeListing: value })
  }

  onSubmit = async (values, actions) => {
    this.hideNotification()
    this.props.setFormLoading(true)
    if (this.state.activeListing) {
      await this.goToBank(values)
    } else {
      this.setState({
        showNotification: true,
        notificationMessage: 'Niste izabrali PROMO paket'
      })
      this.props.setFormLoading(false)
    }
  }

  goToBank = async values => {
    console.log('goToBank values', values)
    const { dial } = this.state
    const { listings, isAuthorized } = this.props

    const selectedListing = listings.find(listing => listing.id === this.state.activeListing)

    if (selectedListing) {
      const bankartTransactionBody = {
        phone: `${dial}${values?.phone?.replace(/ /g, '')}`,
        amount: `${selectedListing.price}`,
        listing: selectedListing.id,
      }

      if (values.adCode) {
        bankartTransactionBody.adCode = values.adCode
      }

      const api = new CommonApi()
      const response = await api.getBankartTransaction(bankartTransactionBody)
      console.log('goToBank response', response)

      if (response?.success && response?.redirectUrl) {
        window.location.href = response.redirectUrl
      } else {
        this.setState({ bankartError: response?.message || t('Došlo je do greške') })
        this.props.setFormLoading(false)
      }
    }
  }

  render() {
    const { dial } = this.state
    const { initialValues, listings, isForApp, formLoading, i18n: { t } } = this.props

    const countries = this.prepareCountries()

    return (
      <Formik onSubmit={this.onSubmit} initialValues={initialValues}>
        <Form className={`online-payment ${isForApp ? 'online-payment-app' : ''}`}>
          <div className='online-payment__fields'>
            <Field id='adCode' name='adCode' label={t('common:Šifra oglasa')} component={TextInput} />
            <div className='form-group'>
              <label>{t('common:Država')}</label>
              <select onChange={this.setDial}>
                {countries.map(country => {
                  if (country.isGrouped) {
                    return <optgroup key={country.id} label={country.label}>
                      {country.options.map(countryChild => <option key={countryChild.id} value={countryChild.value}>{countryChild.label}</option>)}
                    </optgroup>
                  } else {
                    return <option key={country.id} value={country.value}>{country.label}</option>
                  }
                })}
              </select>
            </div>
            <Field
              name='phone'
              id='phone'
              label={t('common:Telefon')}
              component={PhoneInput}
              isRequired
              validate={FormikRequired}
              dial={dial}
            />
          </div>
          <div className='tipovi-oglasa'>
            {listings.map(item =>
              <PromoItem {...item} key={item.id} onClick={this.onListingChange} activeType={this.state.activeListing} />
            )}
          </div>
          <button
            disabled={formLoading}
            key='submit'
            className='btn-oglas-submit ads-add__submit'
            type='submit'
            style={{ backgroundColor: !formLoading ? '#11a73f' : 'gray', cursor: formLoading ? 'not-allowed' : 'pointer' }}
          >
            {t('common:PLATI ODMAH')}
          </button>
          {formLoading ? <Preloader /> : null}
          <div className='bank-transfer-link' style={{ border: 'none' }}>
            <div className='bank-transfer-link__cards'>
              <img height={isForApp ? 48 : 70} src='/icons/visa_pos_fc.png' />
              <img height={isForApp ? 48 : 70} src='/icons/mc_vrt_opt_pos_63_3x.png' />
              <img height={isForApp ? 48 : 70} src='/icons/ms_vrt_opt_pos_73_3x.png' />
              <img height={isForApp ? 48 : 70} src='/icons/mc_idcheck_vrt_pos.png' />
              <img height={isForApp ? 48 : 70} src='/icons/visa-secure_blu_72dpi.jpg' />
              <img height={isForApp ? 48 : 70} src='/icons/Logo_NLB_Banka_sponzorski_10mm_RGB.png' />
            </div>
          </div>
          <FormNotification isActive={this.state.showNotification} message={this.state.notificationMessage} onClose={this.hideNotification} />
        </Form>
      </Formik>
    )
  }
}

const mapStateToProps = state => {
  const user = getUserInfo(state)
  const countries = getCountries(state)

  return {
    countries,
    listings: getListings(state).filter(item => item.price > 0),
    isAuthorized: getIsAuthorized(state),
    formLoading: getFormLoading(state),
    initialValues: {
      phone: user && user.phones ? user.phones[0].phone.replace('382', '') : '',
      adCode: ''
    }
  }
}

ActivatePromoCKB.propTypes = {
  isForApp: PropTypes.bool.isRequired,
  countries: PropTypes.array.isRequired,
  listings: PropTypes.array.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  smsCodeWasSent: PropTypes.bool.isRequired,
  smsCodeVerified: PropTypes.bool.isRequired,
  formLoading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    phone: PropTypes.string,
    adCode: PropTypes.string,
    listing: PropTypes.number
  }),
  setFormLoading: PropTypes.func.isRequired,
  fetchCountries: PropTypes.func.isRequired
}

ActivatePromoCKB.defaultProps = {
  listings: []
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, { setFormLoading, fetchCountries })
)

export default enhance(ActivatePromoCKB)
